(function () {
  const widgetSelector = '.Avada-SubscriptionWidget-Block';
  const optionSelector = '.Avada-ModernSelectionBox';
  const script = document.getElementById('YflSubscriptionClarityScript');
  let planQuantities = {};
  let variantInventory = {};

  try {
    planQuantities = JSON.parse(script?.dataset.planQuantities || '{}');
  } catch (error) {
    console.warn('Unable to read the NOVOS bulk subscription quantities.', error);
  }

  try {
    variantInventory = JSON.parse(script?.dataset.variantInventory || '{}');
  } catch (error) {
    console.warn('Unable to read the NOVOS subscription inventory.', error);
  }

  const commitmentMessages = {
    oneTime: script?.dataset.oneTime || '',
    monthly: script?.dataset.monthly || '',
    sixMonth: script?.dataset.sixMonth || '',
    twelveMonth: script?.dataset.twelveMonth || '',
  };
  const widgetLabels = {
    heading: script?.dataset.widgetHeading || '',
    oneTime: script?.dataset.widgetOneTime || '',
    save: script?.dataset.widgetSave || '',
    each: script?.dataset.widgetEach || '',
    bulkStockNotice: script?.dataset.bulkStockNotice || '',
    bulkUnavailableBadge: script?.dataset.bulkUnavailableBadge || '',
  };

  function normaliseLabel(value) {
    return value.replace(/\s+/g, ' ').trim().toLocaleLowerCase('en');
  }

  const planLabels = new Map(
    [
      ['Annually (12 Boxes Upfront)', script?.dataset.planAnnualBoxes],
      ['Semi-Annually (6 boxes Upfront)', script?.dataset.planSixBoxes],
      ['Monthly (1 Box Upfront)', script?.dataset.planMonthlyBox],
      ['Annually (12 Pouches Upfront)', script?.dataset.planAnnualPouches],
      ['Semi-Annually (6 Pouches Upfront)', script?.dataset.planSixPouches],
      ['Monthly (1 Pouch Upfront)', script?.dataset.planMonthlyPouch],
      ['Prepay every 12 months, receive every 1 month', script?.dataset.planPrepaidTwelveMonths],
      ['Prepay every 6 months, receive every 1 month', script?.dataset.planPrepaidSixMonths],
      ['Every 1 month', script?.dataset.planEveryMonth],
    ]
      .filter(([, translatedLabel]) => translatedLabel)
      .map(([sourceLabel, translatedLabel]) => [normaliseLabel(sourceLabel), translatedLabel])
  );

  function setTextContent(element, value) {
    if (!element || !value || element.textContent?.trim() === value) return;
    element.textContent = value;
  }

  function localisePriceUnit(container) {
    if (!widgetLabels.each) return;

    for (const node of container.childNodes) {
      if (node.nodeType !== 3 || !node.nodeValue?.includes('/each')) continue;
      const localisedValue = node.nodeValue.replaceAll('/each', widgetLabels.each);
      if (localisedValue !== node.nodeValue) node.nodeValue = localisedValue;
    }
  }

  function localiseWidget(widget) {
    setTextContent(widget.querySelector('.Avada-Subscription__Label'), widgetLabels.heading);
    setTextContent(
      widget.querySelector(`${optionSelector}[avada-data-value="one-time-purchase"] .Avada-ModernSelectionBox-Label`),
      widgetLabels.oneTime
    );

    widget.querySelectorAll('.Avada-Block4__LabelText').forEach((label) => {
      const translatedLabel = planLabels.get(normaliseLabel(label.textContent || ''));
      setTextContent(label, translatedLabel);
    });
    widget.querySelectorAll('.Avada-Badge__SaveText').forEach((label) => setTextContent(label, widgetLabels.save));
    widget.querySelectorAll('.Avada-Price__Sale, .Avada-Price__Regular').forEach(localisePriceUnit);
  }

  function getOptionQuantity(option) {
    const label = option.querySelector('.Avada-ModernSelectionBox-Label')?.textContent || '';
    const quantityMatch = label.match(/\b(6|12)\b/);
    return quantityMatch ? Number.parseInt(quantityMatch[1], 10) : 0;
  }

  function getSelectedVariantInventory() {
    const variantInput = document.querySelector('form[action$="/cart/add"] input[name="id"]');
    if (!variantInput?.value) return null;
    return variantInventory[variantInput.value] || null;
  }

  function hasEnoughInventory(quantity) {
    const inventory = getSelectedVariantInventory();
    if (!inventory || !inventory.managed || inventory.policy === 'continue') return true;
    return Number(inventory.quantity) >= quantity;
  }

  function setBulkStockNotice(widget, visible) {
    const selector = widget.querySelector('.Avada-Subscription__Selector');
    if (!selector || !widgetLabels.bulkStockNotice) return;

    let notice = widget.querySelector('.yfl-subscription-stock-notice');
    if (!notice) {
      notice = document.createElement('p');
      notice.className = 'yfl-subscription-stock-notice';
      notice.setAttribute('role', 'status');
      selector.insertAdjacentElement('afterend', notice);
    }

    setTextContent(notice, widgetLabels.bulkStockNotice);
    notice.hidden = !visible;
  }

  function updatePlanAvailability(widget) {
    let hasUnavailableBulkPlan = false;

    widget.querySelectorAll(optionSelector).forEach((option) => {
      const quantity = getOptionQuantity(option);
      const unavailable = quantity > 0 && !hasEnoughInventory(quantity);
      option.classList.toggle('yfl-subscription-option-unavailable', unavailable);
      option.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
      option.dataset.yflSubscriptionUnavailable = unavailable ? 'true' : 'false';

      let badge = option.querySelector('.yfl-subscription-unavailable-badge');
      if (unavailable && widgetLabels.bulkUnavailableBadge) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'yfl-subscription-unavailable-badge';
          option.append(badge);
        }
        setTextContent(badge, widgetLabels.bulkUnavailableBadge);
      } else {
        badge?.remove();
      }

      if (unavailable) hasUnavailableBulkPlan = true;
    });

    const selectedUnavailable = widget.querySelector(
      `${optionSelector}.selected[data-yfl-subscription-unavailable="true"]`
    );
    if (selectedUnavailable) {
      widget.querySelector(`${optionSelector}[avada-data-value="one-time-purchase"]`)?.click();
    }

    setBulkStockNotice(widget, hasUnavailableBulkPlan);
  }

  function updateCommitmentNote(widget) {
    const selected = widget.querySelector(`${optionSelector}.selected`);
    const selector = widget.querySelector('.Avada-Subscription__Selector');
    if (!selected || !selector) return;

    let note = widget.querySelector('.yfl-subscription-commitment-note');
    if (!note) {
      note = document.createElement('p');
      note.className = 'yfl-subscription-commitment-note';
      note.setAttribute('aria-live', 'polite');
      selector.insertAdjacentElement('afterend', note);
    }

    const label = selected.querySelector('.Avada-ModernSelectionBox-Label')?.textContent?.trim() || '';
    const quantityMatch = label.match(/\b(6|12)\b/);
    const prepaidQuantity = quantityMatch ? Number.parseInt(quantityMatch[1], 10) : 0;

    if (selected.getAttribute('avada-data-value') === 'one-time-purchase') {
      note.textContent = commitmentMessages.oneTime;
    } else if (prepaidQuantity === 6) {
      note.textContent = commitmentMessages.sixMonth;
    } else if (prepaidQuantity === 12) {
      note.textContent = commitmentMessages.twelveMonth;
    } else {
      note.textContent = commitmentMessages.monthly;
    }

    synchronisePlanQuantities();
  }

  function getSellingPlanInput(form) {
    return form.querySelector('input[name="selling_plan"]');
  }

  function getQuantityInput(form) {
    const quantityField = form.elements.namedItem('quantity');
    return quantityField instanceof HTMLInputElement ? quantityField : null;
  }

  function getRequiredPlanQuantity(form) {
    const sellingPlanId = getSellingPlanInput(form)?.value?.trim();
    const quantity = Number.parseInt(planQuantities[sellingPlanId], 10);
    return quantity === 6 || quantity === 12 ? quantity : 0;
  }

  function rememberQuantityState(input) {
    if (input.dataset.yflQuantityStateSaved === 'true') return;

    input.dataset.yflQuantityStateSaved = 'true';
    input.dataset.yflOriginalMin = input.getAttribute('min') || '';
    input.dataset.yflOriginalMax = input.getAttribute('max') || '';
    input.dataset.yflOriginalReadonly = input.readOnly ? 'true' : 'false';
  }

  function setQuantityControlsLocked(input, locked) {
    const container = input.closest('quantity-input, .quantity');
    if (!container) return;

    container.classList.toggle('yfl-subscription-quantity-locked', locked);
    container.querySelectorAll('.quantity__button').forEach((button) => {
      button.disabled = locked;
      button.setAttribute('aria-disabled', locked ? 'true' : 'false');
    });
  }

  function lockPlanQuantity(form, quantity) {
    const input = getQuantityInput(form);
    if (!input) return;

    rememberQuantityState(input);
    const nextValue = String(quantity);
    const valueChanged = input.value !== nextValue;

    input.value = nextValue;
    input.min = nextValue;
    input.max = nextValue;
    input.readOnly = true;
    input.setAttribute('aria-readonly', 'true');
    input.dataset.yflBulkQuantity = nextValue;
    setQuantityControlsLocked(input, true);

    if (valueChanged) {
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function unlockPlanQuantity(form) {
    const input = getQuantityInput(form);
    if (!input || !input.dataset.yflBulkQuantity) return;

    const originalMin = input.dataset.yflOriginalMin;
    const originalMax = input.dataset.yflOriginalMax;
    const originalReadonly = input.dataset.yflOriginalReadonly === 'true';

    input.value = originalMin || '1';
    originalMin ? input.setAttribute('min', originalMin) : input.removeAttribute('min');
    originalMax ? input.setAttribute('max', originalMax) : input.removeAttribute('max');
    input.readOnly = originalReadonly;
    input.setAttribute('aria-readonly', originalReadonly ? 'true' : 'false');
    delete input.dataset.yflBulkQuantity;
    setQuantityControlsLocked(input, false);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function applyPlanQuantity(form) {
    const quantity = getRequiredPlanQuantity(form);
    if (quantity) {
      lockPlanQuantity(form, quantity);
    } else {
      unlockPlanQuantity(form);
    }
    return quantity;
  }

  function initialiseProductForm(form) {
    if (form.dataset.yflSubscriptionQuantityGuard === 'true') return;

    form.dataset.yflSubscriptionQuantityGuard = 'true';
    form.addEventListener('formdata', (event) => {
      const quantity = applyPlanQuantity(form);
      if (quantity) event.formData.set('quantity', String(quantity));
    });
  }

  function synchronisePlanQuantities() {
    document.querySelectorAll('form[action$="/cart/add"]').forEach((form) => {
      initialiseProductForm(form);
      applyPlanQuantity(form);
    });
  }

  function initialiseWidget(widget) {
    if (widget.dataset.yflSubscriptionClarity === 'true') return;

    const oneTime = widget.querySelector(`${optionSelector}[avada-data-value="one-time-purchase"]`);
    if (!oneTime) return;

    // Joy places the longest prepaid commitment first. Keep the underlying
    // selling plans unchanged while presenting the lower-commitment choice
    // first in this theme.
    oneTime.parentElement?.prepend(oneTime);

    widget.dataset.yflSubscriptionClarity = 'true';
    widget.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const option = event.target.closest(optionSelector);
      if (!option) return;
      if (option.dataset.yflSubscriptionUnavailable === 'true') {
        event.preventDefault();
        event.stopImmediatePropagation();
        setBulkStockNotice(widget, true);
        return;
      }
      window.setTimeout(() => {
        updateCommitmentNote(widget);
        updatePlanAvailability(widget);
      }, 50);
    }, true);

    const selectionObserver = new MutationObserver(() => updateCommitmentNote(widget));
    selectionObserver.observe(widget, { attributes: true, attributeFilter: ['class'], subtree: true });

    const hasExplicitSellingPlan = new URLSearchParams(window.location.search).has('selling_plan');
    if (!hasExplicitSellingPlan && !oneTime.classList.contains('selected')) oneTime.click();
    updateCommitmentNote(widget);
  }

  function initialiseWidgets() {
    document.querySelectorAll(widgetSelector).forEach((widget) => {
      localiseWidget(widget);
      updatePlanAvailability(widget);
      initialiseWidget(widget);
    });
    synchronisePlanQuantities();
  }

  document.addEventListener(
    'submit',
    (event) => {
      if (!(event.target instanceof HTMLFormElement)) return;
      if (!event.target.matches('form[action$="/cart/add"]')) return;
      applyPlanQuantity(event.target);
    },
    true
  );

  initialiseWidgets();
  document.addEventListener('DOMContentLoaded', initialiseWidgets, { once: true });
  document.addEventListener('variant-change', initialiseWidgets);
  document.addEventListener('change', (event) => {
    if (event.target instanceof HTMLInputElement && event.target.name === 'id') {
      window.setTimeout(initialiseWidgets, 0);
    }
  });

  const widgetObserver = new MutationObserver(initialiseWidgets);
  widgetObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
